export default __webpack_public_path__ + "static/media/delta-light.3eb64518.svg";